import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3 text-grey mb-6" }
const _hoisted_2 = { class: "text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex h-10 w-10 items-center justify-center rounded-lg bg-yellowLight",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeBack && _ctx.routeBack(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
    ]))]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
  ]))
}